import { render, staticRenderFns } from "./BasicInfoEdit.vue?vue&type=template&id=62b22672&scoped=true&"
import script from "./BasicInfoEdit.vue?vue&type=script&lang=js&"
export * from "./BasicInfoEdit.vue?vue&type=script&lang=js&"
import style0 from "./BasicInfoEdit.vue?vue&type=style&index=0&id=62b22672&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b22672",
  null
  
)

export default component.exports